import React from 'react';
import { Layout, Menu } from 'antd';

import { useSystemConfig } from '#/store';
import usePageMenuInfo from '@src/layout/AdsMain/hooks/usePageMenuInfo';

import './style.scss';

const { Sider } = Layout;
const { Item: MenuItem } = Menu;

export default function AdsSidebar() {
  const [{ curTopPageConfig }] = useSystemConfig();
  const { category } = curTopPageConfig.layout || {};

  const { pageMenuInfo, curPageLevelInfo } = usePageMenuInfo({ category });

  // 侧边栏属于第二层级菜单
  const menus = pageMenuInfo[1] || [];

  const selectedKeys = [curPageLevelInfo[1]?.fullPath];

  const curPageInfo = curPageLevelInfo.slice(-1)[0];

  const curPath = curPageInfo?.fullPath;

  const handleClickMenu = (pageInfo) => {
    const { fullPath, subPageSort } = pageInfo;

    if (fullPath === curPath) {
      return;
    }

    let jumpPath = fullPath;

    // 当为父级菜单时，使用子菜单第一个作为跳转链接
    if (subPageSort?.length) {
      jumpPath = subPageSort[0];
    }

    window.router.go(jumpPath, {
      tryRefresh: true,
    });
  };

  if (!category) return null;

  if (!menus.length) return null;

  return (
    <Sider theme={'light'} className={'ads-sidebar'} width={240}>
      <Menu mode={'inline'} selectedKeys={selectedKeys} className={'ads-sidebar-menu'}>
        {menus.map((item) => (
          <MenuItem key={item.fullPath} onClick={() => handleClickMenu(item)}>
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </Sider>
  );
}
